/** Prebuilt footer layouts — single source of truth for the block palette. */
export const FOOTER_PREBUILT_LAYOUTS = [
  {
    id: 'footer-standard',
    name: 'Standard Footer',
    description: 'Copyright text and policy links',
    preview: 'Footer',
    blocks: [
      {
        type: 'footer',
        content: {
          template: 'standard',
          text: '© 2024 Your Company. All rights reserved.',
          links: [
            { text: 'Privacy Policy', url: '#' },
            { text: 'Terms of Service', url: '#' },
          ],
        },
        styles: {
          padding: '48px 24px',
          backgroundColor: '#F8FAFC',
          textAlign: 'center',
          fontSize: '14px',
          color: '#64748B',
          fontFamily: "'Inter', sans-serif",
        },
        mobileStyles: { padding: '24px 16px', fontSize: '13px' },
      },
    ],
  },
  {
    id: 'footer-complete',
    name: 'Complete Footer',
    description: 'Company info, app buttons, and social',
    preview: 'Footer',
    blocks: [
      {
        type: 'footer',
        content: {
          template: 'complete',
          companyName: 'Your Company Name',
          location: 'City, State\nCountry',
          disclaimer:
            'You received this email because you signed up on our website or made a purchase from us.',
          appHeading: 'Use our app on the go',
          appStoreUrl: 'https://apps.apple.com',
          googlePlayUrl: 'https://play.google.com',
          socialPlatforms: [
            { name: 'Facebook', url: '#', icon: 'facebook' },
            { name: 'X', url: '#', icon: 'x' },
            { name: 'Instagram', url: '#', icon: 'instagram' },
          ],
          socialIconColor: '#FFFFFF',
          socialBgColor: '#111827',
        },
        styles: {
          padding: '48px 32px',
          backgroundColor: '#FFFFFF',
          fontSize: '14px',
          color: '#64748B',
          textAlign: 'left',
          fontFamily: "'Inter', sans-serif",
        },
        mobileStyles: { padding: '24px 16px', fontSize: '13px', textAlign: 'center' },
      },
    ],
  },
  {
    id: 'footer-minimal',
    name: 'Minimal Footer',
    description: 'Compact copyright and links',
    preview: 'Footer',
    blocks: [
      {
        type: 'footer',
        content: {
          template: 'minimal',
          text: '© 2024 Your Company',
          links: [
            { text: 'Privacy', url: '#' },
          ],
        },
        styles: {
          padding: '32px 24px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: '12px',
          color: '#94A3B8',
          fontFamily: "'Inter', sans-serif",
        },
        mobileStyles: { padding: '20px 16px', fontSize: '11px' },
      },
    ],
  },
  {
    id: 'footer-gradient',
    name: 'Gradient Footer',
    description: 'Gradient background with links and social icons',
    preview: 'Footer',
    blocks: [
      {
        type: 'footer',
        content: {
          template: 'gradient',
          text: '© 2024 Your Company. All rights reserved.',
          links: [
            { text: 'Privacy', url: '#' },
            { text: 'Terms', url: '#' },
          ],
          socialPlatforms: [
            { name: 'Facebook', url: '#', icon: 'facebook' },
            { name: 'Instagram', url: '#', icon: 'instagram' },
            { name: 'LinkedIn', url: '#', icon: 'linkedin' },
          ],
        },
        styles: {
          padding: '40px 24px',
          backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          textAlign: 'center',
          fontSize: '14px',
          color: '#FFFFFF',
          fontFamily: "'Inter', sans-serif",
        },
        mobileStyles: { padding: '24px 16px', fontSize: '13px' },
      },
    ],
  },
  {
    id: 'footer-social',
    name: 'Social Footer',
    description: 'Centered brand, social icons, and footer links',
    preview: 'Footer',
    blocks: [
      {
        type: 'footer',
        content: {
          template: 'social',
          companyName: 'Your Company',
          text: 'Follow us for updates and exclusive offers',
          links: [
            { text: 'Privacy Policy', url: '#' },
          ],
          socialPlatforms: [
            { name: 'Facebook', url: '#', icon: 'facebook' },
            { name: 'Instagram', url: '#', icon: 'instagram' },
            { name: 'X', url: '#', icon: 'x' },
            { name: 'LinkedIn', url: '#', icon: 'linkedin' },
          ],
        },
        styles: {
          padding: '48px 24px',
          backgroundColor: '#0F172A',
          textAlign: 'center',
          fontSize: '14px',
          color: '#E2E8F0',
          fontFamily: "'Inter', sans-serif",
        },
        mobileStyles: { padding: '24px 16px', fontSize: '13px' },
      },
    ],
  },
];
